import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import CampLejeuneApplicationWrapper from "@components/layouts/campLejeuneApplicationWrapper";

export default function CampLejeuneApplicationHome(): ReactElement {
    return (
        <CampLejeuneApplicationWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <TermsAndConditions
                    category="Camp Lejeune Application"
                    domain="CampLejeuneApplication.com"
                />
            </div>
        </CampLejeuneApplicationWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
